'use strict';
(function () {
	angular.module('dat.shared-components.equipment')
		.directive('datEquipmentSelect', datEquipmentSelect);

	datEquipmentSelect.$inject = ['EquipmentService', '$parse', '$log', 'eventNameService'];

	var equipmentService, $parse, $log, eventNameService;

	function datEquipmentSelect(_equipmentService_, _$parse_, _$log_, _eventNameService_) {
		equipmentService = _equipmentService_;
		$parse = _$parse_;
		$log = _$log_;
		eventNameService = _eventNameService_;

		return {
			restrict: 'EA',
			templateUrl: '/app/shared-components/equipment/equipment-select.html',
			compile: function () {
				return {
					pre: preLink,
					post: postLink
				};
			}
		};
	}

	function preLink (scope, element, attrs) {
		scope.inputId = scope.$id;
		scope.typesOptions = getTypeOptions(scope);
		scope.classesOptions = getClassOptions(scope);
		scope.cached = {types: [], classes: []};
		scope.toggleTabindex = $parse(attrs.toggleTabindex)(scope);
		scope.selectTabindex = $parse(attrs.selectTabindex)(scope);

		var classes = $parse(attrs.classes)(scope),
			types = $parse(attrs.types)(scope),
			excludeClass = attrs.excludeClass;

		activate();

		///////////////////////////////////////////

		function activate() {
			initializeEquipment();
			equipmentService.getEquipmentSetData().then(function () {
				if (excludeClass) {
					equipmentService.removeClass(excludeClass);
				}
				//if classes or types initializes correctly when switching from view mode to edit mode
				scope.equipment.classes = equipmentService.getEquipmentClasses(classes);
				scope.equipment.types = equipmentService.getEquipmentTypes(types);
				scope.equipment.classMode = $parse(attrs.isClassMode)(scope);
				scope.equipment.isDualMode = attrs.isDualMode ? $parse(attrs.isDualMode)(scope) : true;

				scope.cached = {
					classes: equipmentService.getEquipmentClasses($parse(attrs.classes)(scope)),
					types: equipmentService.getEquipmentTypes($parse(attrs.types)(scope))
				};
			});

			scope.$on(eventNameService.equipmentSelect.equipmentParsed, onEquipmentParsed);
			scope.$on(eventNameService.equipmentSelect.emptySearchInitialized, onEmptySearchInitialized);
			scope.$on(eventNameService.equipmentSelect.closeAndOpen, onCloseAndOpen);
		}

		function initializeEquipment() {
			scope.equipment = {
				classes: null,
				types: null,
				classMode: $parse(attrs.isClassMode)(scope),
				isDualMode: attrs.isDualMode ? $parse(attrs.isDualMode)(scope) : true
			};
		}

		function onEquipmentParsed() {
			$log.debug('Equipment-select directive: onEquipmentParsed called');
			scope.cached = {
				classes: equipmentService.getEquipmentClasses($parse(attrs.classes)(scope)),
				types: equipmentService.getEquipmentTypes($parse(attrs.types)(scope))
			};
			if (angular.mock) $log.debug('scope.cached dump: ' + angular.mock.dump(scope.cached));

			if (scope.cached.classes.length > 0) {
				scope.equipment.classes = scope.cached.classes;
			} else if (scope.cached.types.length > 0) {
				scope.equipment.types = scope.cached.types;
			}
			scope.equipment.classMode = $parse(attrs.isClassMode)(scope);
		}

		function onCloseAndOpen() {
			element.find('.select2-container').select2('close');
			openEquipmentDropdown(scope);
		}

		function onEmptySearchInitialized() {
			$log.debug('onEmptySearchInitialized called');
			initializeEquipment();
			openEquipmentDropdown(scope);
		}
	}

	function postLink (scope, element, attrs) {
		var typeSelectInputSelector = 'input[id*=searchEquipmentTypesSelect2]',
			classSelectInputSelector = 'input[id*=searchEquipmentClassesSelect2]',
			divContainerPrevScrollPosition;

		scope.toggle = function () {
			if (scope.equipment) {
				scope.equipment.classMode = !scope.equipment.classMode;

				if (scope.equipment.classMode) {
					scope.cached.types = angular.copy(scope.equipment.types);
					scope.equipment.types = [];

					if (scope.cached.classes && scope.cached.classes.length > 0) {
						scope.equipment.classes = angular.copy(scope.cached.classes);
					}
				} else {
					scope.cached.classes = angular.copy(scope.equipment.classes);
					scope.equipment.classes = [];

					if (scope.cached.types && scope.cached.types.length > 0) {
						scope.equipment.types = angular.copy(scope.cached.types);
					}
				}

				openEquipmentDropdown(scope);

				//TODO: Update for sticky values
				scope.$emit('SearchEquipmentSetToggleMode');
			}
		};

		scope.$watch('equipment.classMode', function (value) {
			if (value) {
				scope.filterButtonText = 'any';
			} else {
				scope.filterButtonText = 'only';
			}
		});

		element.find(typeSelectInputSelector + ',' + classSelectInputSelector).on('select2-blur', function () {
			//TODO: Update for sticky values
			scope.$emit('SearchEquipmentSetBlur');
		});

		element.parents('div').scroll(function () {
			var divContainerCurrentScrollTopPos = $(this).scrollTop();

			if (divContainerPrevScrollPosition !== divContainerCurrentScrollTopPos) {
				element.find('.select2-container').select2('close');
				divContainerPrevScrollPosition = divContainerCurrentScrollTopPos;
			}
		});

		scope.$watchCollection('equipment.classes', function (classes) {
			if (classes && attrs.classes) {
				$parse(attrs.classes).assign(scope, _.pluck(classes, 'id'));
				if (attrs.types && classes.length > 0) { //If types configured and classes selected, clear types model
					$parse(attrs.types).assign(scope, []);
				}
				scope.m.equipmentOptions.equipmentValidation.invalid = false;
				scope.m.equipmentOptions.equipmentValidation.message = '';
			}
			$log.debug('Equipment-select directive: classes watch executed');
		});

		scope.$watchCollection('equipment.types', function (types) {
			if (types && attrs.types) {
				$parse(attrs.types).assign(scope, _.pluck(types, 'id'));
				if (attrs.classes && types.length > 0) { //If classes configured and types selected, clear classes model
					$parse(attrs.classes).assign(scope, []);
				}
				scope.m.equipmentOptions.equipmentValidation.invalid = false;
				scope.m.equipmentOptions.equipmentValidation.message = '';
			}
			$log.debug('Equipment-select directive: types watch executed');
		});

		scope.$watch('m.disableEquipmentSelect.disable', function() {
			if (scope.m.disableEquipmentSelect.disable === true){
				element.find('.select2-container').select2('enable', false);
			} else{
				element.find('.select2-container').select2('enable', true);
			}
		});

		scope.$watch('m.equipmentOptions.equipmentValidation.invalid', function (){
			if (scope.m.equipmentOptions.equipmentValidation.invalid){
				element.find('.select2-container').addClass('ng-invalid-input');
			} else {
				element.find('.select2-container').removeClass('ng-invalid-input');
			}
		});
	}

	function getTypeOptions(scope) {
		var options = equipmentService.getSelect2BaseOptions();
		options.width = '100%';
		options.tokenSeparators = [','];
		options.selectOnBlur = false; // disable autoselect on blur (i.e. Applies only for bluring by clicking outside of the dropdown)
		//options.externalClickTarget = 'div.content';  //Commented out because it was suppressing the onblur
		options.placeholder = 'e.g. Van Conestoga';
		options.query = equipmentService.searchTypes;
		options.disableAutoSelectFirstOptionWhenEmpty = true;
		options.createSearchChoice = function (term) {
			var currentTypeCodes = $('#searchEquipmentTypesSelect2' + scope.inputId).val(),
				selectedEquipment = equipmentService.getEquipmentTypes(currentTypeCodes),
				result = equipmentService.createTypeItem(term, selectedEquipment);

			return result;
		};
		options.sortResults = equipmentService.sortTypes;

		return options;
	}

	function getClassOptions(scope) {
		var options = equipmentService.getSelect2BaseOptions();
		options.width = '100%';
		options.tokenSeparators = [','];
		options.selectOnBlur = false; // disable autoselect on blur (i.e. Applies only for bluring by clicking outside of the dropdown)
		//options.externalClickTarget = 'div.content';  //Commented out because it was suppressing the onblur
		options.placeholder = 'e.g. Flatbeds';
		options.query = equipmentService.searchClasses;
		options.disableAutoSelectFirstOptionWhenEmpty = true;
		options.createSearchChoice = function (term) {
			var currentClassCodes = $('#searchEquipmentClassesSelect2' + scope.inputId).val(),
				selectedEquipment = equipmentService.getEquipmentClasses(currentClassCodes),
				result = equipmentService.createClassItem(term, selectedEquipment);

			return result;
		};
		options.sortResults = equipmentService.sortClasses;

		return options;
	}

	function openEquipmentDropdownForSelectedMode(scope) {
		var currentSelectFilterId = '#' + (scope.equipment.classMode ? 'searchEquipmentClassesSelect2' : 'searchEquipmentTypesSelect2') + scope.inputId;
		$(currentSelectFilterId).select2('open');
	}

	function openEquipmentDropdown(scope) {
		if (scope.equipment.isDualMode) {
			setTimeout(function () {
				openEquipmentDropdownForSelectedMode(scope);
			}, 0);
		} else {
			openEquipmentDropdownForSelectedMode(scope);
		}
	}
})();
